import { ifProp } from './ifProp';

/**
 * @deprecated Please use web-common version
 */
export const prop =
  <T, U>(key: keyof T, fallback?: U) =>
  (props: T) =>
    ifProp(key, props[key], fallback);
